module.exports = __webpack_public_path__ + "media/images/category_icons/websites-83bcfa1a4af0ae20b0a1202628828fe1.svg";